import React from "react";
import { Link } from "react-router";
import { RUBRIC_COLOR } from "../../tokens";

export const PrayButton: React.FC<{
    link: string;
    title: string;
    subtitle: string;
}> = (props) => {
    const { link, title, subtitle } = props;

    return (
        <div
            style={{
                padding: 16,
                paddingBottom: 16,
                width: 200,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    fontSize: "110%",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                }}
            >
                {title}
            </div>
            <div
                style={{
                    paddingBottom: 10,
                    fontWeight: "bold",
                    color: RUBRIC_COLOR,
                }}
            >
                {subtitle}
            </div>
            <Link
                to={link}
                style={{
                    textDecoration: "none",
                    border: `1px solid ${RUBRIC_COLOR}`,
                    color: RUBRIC_COLOR,
                    paddingTop: 8,
                    paddingRight: 16,
                    paddingBottom: 10,
                    paddingLeft: 16,
                    borderRadius: 4,
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    textTransform: "uppercase",
                    fontSize: "90%",
                    fontWeight: "bold",
                    letterSpacing: 0.1,
                }}
            >
                Pray {title}
            </Link>
        </div>
    );
};
